import {
  Typography,
  Button,
  LinearProgress,
  Box,
  Tab,
  Tabs,
  Divider,
} from "@mui/material";
import * as React from "react";
import { useUserContext } from "../../../contexts/ProviderProvider";
import {
  getCollectionsReady,
  getCurrentlyRunning,
  getProductsReady,
  getTeamCollectionsReady,
  getTeamProductsReady,
  runHattrickOn,
  stopHattrick,
} from "../../../API/hattrick";
import _ from "lodash";
import CurrentlyRunning from "./CurrentlyRunning";
import HattrickProductReadyTable from "./HattrickProductReadyTable";
import HattrickCollectionReadyTable from "./HattrickCollectionsReadyTable";
import SchoolSportFilter from "../../common/SchoolSportFilter";
import { useNavigate } from "react-router";
import useNotification from "../../../hooks/useNotification";
import { getUniversityProductCount } from "../../../API/products";
import GrandSlamRunningAnalytics from "./GrandSlamRunningAnalytics";
import axios from "axios";
import HattrickTeamCollectionReadyTable from "./HattrickTeamCollectionsReadyTable";
import HattrickTeamProductReadyTable from "./HattrickTeamProductReadyTable";

const GrandSlam = (props) => {
  const [selectedSchool, setSelectedSchool] = React.useState("");
  const [selectedSport, setSelectedSport] = React.useState("");
  const [products, setProducts] = React.useState([]);
  const [collections, setCollections] = React.useState([]);
  const [teamProducts, setTeamProducts] = React.useState([]);
  const [teamCollections, setTeamCollections] = React.useState([]);
  const [currentlyRunning, setCurrentlyRunning] = React.useState([]);

  const [activeTab, setActiveTab] = React.useState(0);
  const [refresh, setRefresh] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [schoolCountLoading, setSchoolCountLoading] = React.useState(true);
  const [universityCount, setUniversityCount] = React.useState({});
  const [canRun, setCanRun] = React.useState(true);

  const tabNames = ["Products", "Team Products", "Collections", "Team Collections", "Analytics"]
  const dataSource = [products, teamProducts, collections, teamCollections]

  const getActiveTabName = () => tabNames[activeTab] || "Unknown Tab";
  const hasItems = () => (dataSource[activeTab]?.length ?? 0) > 0;

  React.useEffect(() => {
    console.log("refresh changes:", refresh)
  }, [refresh])

  console.log(`props school`, props.school);
  console.log(`props sport`, props.sport);

  const navigate = useNavigate();
  const notify = useNotification();
  const user = useUserContext();

  const debouncedSetSelectedSchoolViaUrl = React.useCallback(
    _.debounce((school) => {
      if (school !== selectedSchool) {
        navigate(
          "/ballpark/grandslam" +
          (school ? "/" + btoa(school) : "") +
          (selectedSport ? "/" + btoa(selectedSport) : "")
        );
      }
    }, 300),
    [selectedSchool, selectedSport]
  );

  const debouncedSetSelectedSportViaUrl = React.useCallback(
    _.debounce((sport) => {
      if (sport !== selectedSport) {
        navigate(
          "/ballpark/grandslam" +
          (selectedSchool ? "/" + btoa(selectedSchool) : "") +
          (sport ? "/" + btoa(sport) : "")
        );
      }
    }, 300),
    [selectedSchool, selectedSport]
  );

  const updateUniversityCount = React.useCallback((results) => {
    const counts = {}

    const addCount = (schoolName, prodCount = 0, collCount = 0) => {
      const curr = counts[schoolName] || [0, 0];
      counts[schoolName] = [curr[0] + prodCount, curr[1] + collCount];
    };

    for (const { schoolName, selectedCount } of results.products || []) {
      addCount(schoolName, selectedCount, 0);
    }
    for (const { schoolName, selectedCount } of results.team_products || []) {
      addCount(schoolName, selectedCount, 0);
    }
    for (const { schoolName, selectedCount } of results.collections || []) {
      addCount(schoolName, 0, selectedCount);
    }
    for (const { schoolName, selectedCount } of results.team_collections || []) {
      addCount(schoolName, 0, selectedCount);
    }

    setUniversityCount(counts)
    setSchoolCountLoading(false)
  }, []);

  const updateCurrentlyRunning = React.useCallback(
    (newVal) => {
      const currentJSON = JSON.stringify(currentlyRunning);
      const newJSON = JSON.stringify(newVal);

      if (currentJSON !== newJSON) {
        setCurrentlyRunning(newVal);
      }
    },
    [currentlyRunning]
  );

  // const setSelectedSportViaUrl = (sport) => {
  //   //console.log("redirecting sport");
  //   navigate(
  //     "/ballpark/grandslam" +
  //       (selectedSchool ? "/" + btoa(selectedSchool) : "") +
  //       (sport ? "/" + btoa(sport) : "")
  //   );
  // };

  // const setSelectedSchoolViaUrl = (school) => {
  //   navigate(
  //     "/ballpark/grandslam" +
  //       (school ? "/" + btoa(school) : "") +
  //       (selectedSport ? "" + btoa(selectedSport) : "")
  //   );
  // };

  const stopGrandSlam = () => {
    setLoading(true);
    stopHattrick(user)
      .then((response) => {
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        notify("Failed to stop. Grandslam cannot be contained");
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (props.school && props.school !== selectedSchool) {
      setSelectedSchool(props.school);
    }

    if (props.sport && props.sport !== selectedSport) {
      setSelectedSport(props.sport);
    }
  }, [props.school, props.sport]);

  React.useEffect(() => {
    if (!user) return;

    if (selectedSchool || selectedSport) {
      const itemsExists = hasItems()
      setCanRun(itemsExists);
    } else {
      setCanRun(true);
    }
  }, [activeTab, selectedSchool, selectedSport, products, collections, teamProducts, teamCollections, user]);

  React.useEffect(() => {
    if (!user) return;

    getCurrentlyRunning(user)
      .then((response) => {
        updateCurrentlyRunning(response.data.obj);
      })
      .catch((error) => {
        console.error(error);
        notify("Failed to get hattrick running state");
        updateCurrentlyRunning([]);
      });
  }, [refresh, updateCurrentlyRunning, user, notify]);

  React.useEffect(() => {
    if (!user) return;

    const pollId = setInterval(() => {
      if (!document.hidden) {
        getCurrentlyRunning(user)
          .then((response) => {
            updateCurrentlyRunning(response.data.obj);
          })
          .catch((error) => {
            console.error(error);
            notify("Failed to get hattrick running state");
            setCurrentlyRunning([]);
          });
      }
    }, 5000);

    return () => {
      clearInterval(pollId);
    };
  }, [user, updateCurrentlyRunning, notify]);

  React.useEffect(() => {
    if (!user) return;

    const source = axios.CancelToken.source();

    getUniversityProductCount(user, { cancelToken: source.token })
      .then((response) => {
        updateUniversityCount(response.data);
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          // cl
          console.log(`Request cancelled`);
        } else {
          notify("Failed to get product university counts");
        }
      });

    return () => {
      source.cancel(
        "Operation canceled due to new request or component unmount"
      );
    };
  }, [user, updateUniversityCount, notify]);

  React.useEffect(() => {

    const fetchData = async () => {
      if (!user || loading || selectedSchool?.length < 3) {
        setProducts([]);
        setTeamProducts([]);
        setCollections([]);
        setTeamCollections([]);
        return;
      }

      setLoading(true);

      try {
        const [productRes, teamProductRes, collectionRes, teamCollectionRes] = await Promise.all([
          getProductsReady(selectedSchool, selectedSport || "", user),
          getTeamProductsReady(selectedSchool, selectedSport || "", user),
          getCollectionsReady(selectedSchool, selectedSport, user),
          getTeamCollectionsReady(selectedSchool, selectedSport, user),
        ]);

        setProducts(productRes?.data?.obj || []);
        setTeamProducts(teamProductRes?.data?.obj || []);
        setCollections(collectionRes?.data?.obj || []);
        setTeamCollections(teamCollectionRes?.data?.obj || []);
      } catch (error) {
        console.log("error fetching ready records: ", error);
        notify("failed to fetch one or more datasets");
        setProducts([]);
        setTeamProducts([]);
        setCollections([]);
        setTeamCollections([]);
      } finally {
        setLoading(false)
      }
    }

    fetchData();

  }, [user, selectedSchool, selectedSport, currentlyRunning])

  const runAll = async () => {
    let payload;
    let team_payload;
    let type;

    switch (activeTab) {
      case 0:
        payload = products.map((p) => ({
          type_id: p.ProductId,
          roster_id: p.RosterId,
        }));
        type = "products"
        break;
      case 1:
        team_payload = teamProducts.map((p) => ({
          type_id: p.team_product_id,
          team_id: p.team_id,
        }));
        type = "team products";
        break;
      case 2:
        payload = collections.map((p) => ({
          type_id: p.CollectionId,
          roster_id: p.RosterId,
        }));
        type = "collections"
        break;
      case 3:
        team_payload = teamCollections.map((p) => ({
          type_id: p.CollectionId,
          team_id: p.TeamId,
        }));
        type = "team collections";
        break;
      default:
        notify("Inavlid Tab Selected");
        return;
    }

    try {
      const response = await runHattrickOn(
        {
          type: type,
          ...(payload && { running: payload }),
          ...(team_payload && { team_running: team_payload })
        },
        user
      )
      console.log('response running: runHattrickOn', response)
    } catch (error) {
      console.error(error);
      notify("Failed to get hattrick running state");
    } finally {
      setRefresh((p) => p + 1)
    }
  };

  const tabComponents = [
    <HattrickProductReadyTable
      currentlyRunning={currentlyRunning}
      data={products}
      refresh={() => setRefresh((p) => p + 1)}
    />,
    <HattrickTeamProductReadyTable
      currentlyRunning={currentlyRunning}
      data={teamProducts}
      refresh={() => setRefresh((p) => p + 1)}
    />,
    <HattrickCollectionReadyTable
      currentlyRunning={currentlyRunning}
      data={collections}
      refresh={() => setRefresh((p) => p + 1)}
    />,
    <HattrickTeamCollectionReadyTable
      currentlyRunning={currentlyRunning}
      data={teamCollections}
      refresh={() => setRefresh((p) => p + 1)}
    />,
    <div>
      <GrandSlamRunningAnalytics />
    </div>
  ]

  if (!user) {
    return <></>;
  }
  return (
    <div style={{ width: "80%" }}>
      <Typography variant="h1">Grand Slam</Typography>
      <span
        style={{
          opacity: "0.4",
          fontSize: "14",
          marginLeft: "0px",
          position: "relative",
          top: "-10px",
        }}
      >
        {getActiveTabName()} ready for Grandslam!
      </span>
      <br />
      <Button variant="outlined" color="error" onClick={stopGrandSlam}>
        Stop Slammin'
      </Button>
      <CurrentlyRunning
        currentlyRunning={currentlyRunning}
        products={products}
        collections={collections}
      />
      <SchoolSportFilter
        setSelectedSchool={debouncedSetSelectedSchoolViaUrl}
        setSelectedSport={debouncedSetSelectedSportViaUrl}
        selectedSchool={selectedSchool}
        selectedSport={selectedSport}
        universitiesCount={universityCount}
        schoolCountLoading={schoolCountLoading}
      />
      <Divider sx={{ marginTop: "15px", marginBottom: "10px" }} />
      <Button
        sx={{ width: "100%" }}
        variant={"contained"}
        onClick={runAll}
        disabled={!canRun}
      >
        Run All {getActiveTabName()} With Current Filter
      </Button>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={activeTab} onChange={(e, nv) => setActiveTab(nv)}>
          {tabNames.map((tab, index) => (
            <Tab key={index} label={tab} />
          ))}
        </Tabs>
      </Box>
      {(Object.keys(currentlyRunning).length > 0 || loading) && (
        <LinearProgress />
      )}
      <div>
        {tabComponents[activeTab] || <div>Invalid Tab</div>}
      </div>
    </div>
  );
};

export default GrandSlam;
